<template>
  <div>
    <div class="position-absolute" style="left: 0; top: 0;">
      <div class="fix-alert">
        <b-alert 
          v-model="alertOpen" 
          dismissible
          variant="info"
          style="min-height: 53px;"
        >
          {{ alertSumLine || 'Операций не найдено' }}
          <!-- <template v-if="alertOperationTable.length > 0">
            <hr />            
          </template> -->
        </b-alert>    
      </div>
    </div>

    <table id="bdr-result-table" data-cols-width="7,60,13,13,13,13,13,13,13,13,13,13,13,13,13">
      <thead>
        <tr>
          <th class="bdr-result-table-point"></th>
          <th class="bdr-result-table-main-cell bdr-result-table-header-text" data-f-sz="14" data-f-bold="true">Борский Стекольный Завод</th>
          <th v-for="month in 12" :key="month" class="bdr-result-table-text-align-end"></th>
          <th class="bdr-result-table-text-align-end"></th>
        </tr>
        <tr>
          <th colspan="15" class="bdr-result-table-main-header" data-fill-color="FFFFFFCC" data-b-a-s="medium" data-f-sz="14" data-f-bold="true">
            БЮДЖЕТ ДОХОДОВ И РАСХОДОВ за {{ year }} г
          </th>
        </tr>
        <tr>
          <th class="bdr-result-table-point" data-a-wrap="true" data-b-a-s="thin" data-f-bold="true">№ п/п</th>
          <th class="bdr-result-table-main-cell" data-b-a-s="thin"></th>
          <th v-for="month in months" :key="month" data-b-a-s="medium" data-a-v="middle" data-f-bold="true">{{ month }}</th>
          <th data-b-a-s="medium" data-a-v="middle" data-f-bold="true">ИТОГО</th>
        </tr>
      </thead>

      <tbody>
        <!-- for bdr[0] -->
        <tr class="bdr-result-table-name-row">
          <th 
            colspan="2" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium" 
            data-f-sz="12" 
            data-f-bold="true"
          >{{ bdr[0].children[0].external_number }} {{ bdr[0].name }}</th>
          <th 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium"
          ></th>
          <th 
            v-for="month in 12" 
            :key="month" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium"
          ></th>
        </tr>
        <!-- row -->
        <tr v-for="child in bdr[0].children[0].children" :key="child.id">
          <!-- number of point -->
          <th 
            class="bdr-result-table-point" 
            data-a-v="middle" 
            data-f-bold="true" 
            data-b-a-s="thin" 
            data-b-r-s="medium"
          >{{ child.external_number }}</th>
          <!-- name of child -->
          <th 
            class="bdr-result-table-main-cell" 
            data-a-wrap="true" 
            data-a-v="middle"
            data-f-bold="true" 
            data-b-a-s="thin" 
            data-b-r-s="medium"
          >{{ child.name }}</th>
          
          <!-- sum of operation in current month -->
          <!-- for browser -->
          <th 
            v-for="month in 12" 
            :key="month" 
            data-exclude="true" 
            class="bdr-result-table-text-align-end"
            style="cursor: pointer"
            @click="calcMonthOperations(child.operations, month)"
          >{{ calcMonthSum(child.operations, month).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            v-for="month in 12" 
            :key="month + 12" 
            class="bdr-result-table-text-align-end hidden"
            data-a-v="middle" 
            data-b-a-s="thin" 
            data-b-r-s="medium" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)" 
          >{{ calcMonthSum(child.operations, month) }}</th>

          <!-- sum of child's operations -->
          <th 
            class="bdr-result-table-text-align-end" 
            data-exclude="true"
          >{{ calcRowSum(child.operations).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            class="bdr-result-table-text-align-end hidden" 
            data-a-v="middle" 
            data-b-a-s="thin" 
            data-b-r-s="medium" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcRowSum(child.operations) }}</th>
        </tr>

        <tr class="bdr-result-table-name-row">
          <th 
            class="bdr-result-table-point" 
            colspan="2" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium" 
            data-f-sz="12" 
            data-f-bold="true"
          >ИТОГО ВЫРУЧКА:</th>

          <!-- sum of all children in current month-->
          <th 
            v-for="month in 12" 
            :key="month" 
            class="bdr-result-table-text-align-end" 
            data-exclude="true"
          >{{ calcColumnSum(bdr[0].children[0].children, month).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            v-for="month in 12" 
            :key="month + 12" 
            class="bdr-result-table-text-align-end hidden" 
            data-b-a-s="medium" 
            data-fill-color="FFFFCC00" 
            data-f-bold="true" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcColumnSum(bdr[0].children[0].children, month) }}</th>

          <!-- sum of all operations -->
          <th 
            class="bdr-result-table-text-align-end" 
            data-exclude="true"
          >{{ calcAllSums(bdr[0].children[0].children).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            class="bdr-result-table-text-align-end hidden" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium" 
            data-f-bold="true" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcAllSums(bdr[0].children[0].children) }}</th>
        </tr>

        <!-- for bdr 1 -->
        <tr class="bdr-result-table-name-row">
          <th 
            class="bdr-result-table-point" 
            colspan="2" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium" 
            data-f-sz="12" 
            data-f-bold="true"
          >{{ bdr[1].children[0].external_number }} {{ bdr[1].name }}</th>
          <th 
            data-fill-color="FFFFCC00"
            data-b-a-s="medium"
          ></th>
          <th 
            v-for="month in 12" 
            :key="month" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium"
          ></th>
        </tr>
        <tr v-for="child in bdr[1].children[0].children" :key="child.id">
          <th 
            class="bdr-result-table-point" 
            data-a-v="middle" 
            data-f-bold="true" 
            data-b-a-s="thin" 
            data-b-r-s="medium"
          >{{ child.external_number }}</th>
          <th 
            class="bdr-result-table-main-cell" 
            data-a-wrap="true" 
            data-a-v="middle"
            data-f-bold="true" 
            data-b-a-s="thin" 
            data-b-r-s="medium"
          >{{ child.name }}</th>

          <th 
            v-for="month in 12" 
            :key="month" 
            data-exclude="true" 
            class="bdr-result-table-text-align-end"
            style="cursor: pointer"
            @click="calcMonthOperations(child.operations, month)"
          >{{ calcMonthSum(child.operations, month).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            v-for="month in 12" 
            :key="month + 12" 
            class="bdr-result-table-text-align-end hidden"
            data-a-v="middle" 
            data-b-a-s="thin" 
            data-b-r-s="medium" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)" 
          >{{ calcMonthSum(child.operations, month) }}</th>

          <th 
            class="bdr-result-table-text-align-end" 
            data-exclude="true"
          >{{ calcRowSum(child.operations).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            class="bdr-result-table-text-align-end hidden" 
            data-a-v="middle" 
            data-b-a-s="thin" 
            data-b-r-s="medium" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcRowSum(child.operations) }}</th>
        </tr>

        <tr class="bdr-result-table-name-row">
          <th 
            class="bdr-result-table-point" 
            colspan="2" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium" 
            data-f-sz="12" 
            data-f-bold="true"
          >ИТОГО ПЕРЕМЕННЫЕ ЗАТРАТЫ</th>

          <th 
            v-for="month in 12" 
            :key="month" 
            class="bdr-result-table-text-align-end" 
            data-exclude="true"
          >{{ calcColumnSum(bdr[1].children[0].children, month).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            v-for="month in 12" 
            :key="month + 12" 
            class="bdr-result-table-text-align-end hidden" 
            data-b-a-s="medium" 
            data-fill-color="FFFFCC00" 
            data-f-bold="true" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcColumnSum(bdr[1].children[0].children, month) }}</th>

          <th 
            class="bdr-result-table-text-align-end" 
            data-exclude="true"
          >{{ calcAllSums(bdr[1].children[0].children).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            class="bdr-result-table-text-align-end hidden" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium" 
            data-f-bold="true" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcAllSums(bdr[1].children[0].children) }}</th>
        </tr>

        <tr class="bdr-result-table-name-row">
          <th 
            class="bdr-result-table-point" 
            colspan="2" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium" 
            data-f-sz="12" 
            data-f-bold="true"
          >МАРЖИНАЛЬНАЯ ПРИБЫЛЬ</th>

          <th 
            v-for="month in 12" 
            :key="month"
            class="bdr-result-table-text-align-end"
            data-exclude="true"
          >
            {{ calcMarginProfitMonth(bdr[0].children[0].children, bdr[1].children[0].children, month).toLocaleString() }}
          </th>
          <!-- hidden, for export -->
          <th 
            v-for="month in 12" 
            :key="month + 12"
            class="bdr-result-table-text-align-end hidden"
            data-b-a-s="medium" 
            data-fill-color="FFFFCC00" 
            data-f-bold="true" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >
            {{ calcMarginProfitMonth(bdr[0].children[0].children, bdr[1].children[0].children, month) }}
          </th>

          <th 
            class="bdr-result-table-text-align-end" 
            data-exclude="true"
          >{{ calcMarginProfitAll(bdr[0].children[0].children, bdr[1].children[0].children).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            class="bdr-result-table-text-align-end hidden" 
            data-b-a-s="medium" 
            data-fill-color="FFFFCC00" 
            data-f-bold="true" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcMarginProfitAll(bdr[0].children[0].children, bdr[1].children[0].children) }}</th>
        </tr>

        <!-- for bdr 2 -->
        <tr class="bdr-result-table-name-row">
          <th 
            colspan="2" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium" 
            data-f-sz="12" 
            data-f-bold="true"
          >{{ bdr[2].name }}</th>
          <th 
            data-fill-color="FFFFCC00"
            data-b-a-s="medium"
          ></th>
          <th 
            v-for="month in 12" 
            :key="month" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium"
          ></th>
        </tr>
        <tr v-for="child in allChildren(bdr[2].children)" :key="child.id">
          <th 
            class="bdr-result-table-point" 
            data-a-v="middle" 
            data-f-bold="true" 
            data-b-a-s="thin" 
            data-b-r-s="medium"
          >{{ child.external_number }}</th>
          <th 
            class="bdr-result-table-main-cell" 
            data-a-wrap="true" 
            data-a-v="middle"
            data-f-bold="true" 
            data-b-a-s="thin" 
            data-b-r-s="medium"
          >{{ child.name }}</th>
          <th 
            v-for="month in 12" 
            :key="month" 
            class="bdr-result-table-text-align-end"
            data-exclude="true" 
            style="cursor: pointer"
            @click="calcMonthOperationsWithSubRow(child, month)"
          >{{ calcSumSubPoints(child, month).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            v-for="month in 12" 
            :key="month + 12" 
            class="bdr-result-table-text-align-end hidden"
            data-a-v="middle" 
            data-b-a-s="thin" 
            data-b-r-s="medium"
            data-t="n" 
            data-num-fmt="_(### ### ##0_)" 
            style="cursor: pointer"
            @click="calcMonthOperationsWithSubRow(child, month)"
          >{{ calcSumSubPoints(child, month) }}</th>

          <th 
            class="bdr-result-table-text-align-end"
            data-exclude="true"
          >{{ calcSumWithSubRow(child).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            class="bdr-result-table-text-align-end hidden"
            data-a-v="middle" 
            data-b-a-s="thin" 
            data-b-r-s="medium"
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcSumWithSubRow(child) }}</th>
        </tr>

        <tr class="bdr-result-table-name-row">
          <th 
            class="bdr-result-table-point" 
            colspan="2" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium" 
            data-f-sz="12" 
            data-f-bold="true"
          >ИТОГО ПОСТОЯННЫЕ ЗАТРАТЫ</th>
          <th 
            v-for="month in 12" 
            :key="month" 
            class="bdr-result-table-text-align-end" 
            data-exclude="true"
          >{{ calcSumSubCols(allChildren(bdr[2].children), month).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            v-for="month in 12" 
            :key="month + 12" 
            class="bdr-result-table-text-align-end hidden" 
            data-b-a-s="medium" 
            data-fill-color="FFFFCC00" 
            data-f-bold="true"
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcSumSubCols(allChildren(bdr[2].children), month) }}</th>

          <th 
            class="bdr-result-table-text-align-end" 
            data-exclude="true"
          >{{ calcAllSubSums(allChildren(bdr[2].children)).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            class="bdr-result-table-text-align-end hidden" 
            data-b-a-s="medium" 
            data-fill-color="FFFFCC00" 
            data-f-bold="true" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcAllSubSums(allChildren(bdr[2].children)) }}</th>
        </tr>

        <!-- ПРИБЫЛЬ -->
        <tr class="bdr-result-table-name-row">
          <th 
            class="bdr-result-table-point" 
            colspan="2" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium" 
            data-f-sz="12" 
            data-f-bold="true"
          >ПРИБЫЛЬ</th>
          <th 
            v-for="month in 12" 
            :key="month" 
            class="bdr-result-table-text-align-end" 
            data-exclude="true"
          >{{ calcProfitCols(bdr, month).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            v-for="month in 12" 
            :key="month + 12" 
            class="bdr-result-table-text-align-end hidden" 
            data-b-a-s="medium" 
            data-fill-color="FFFFCC00" 
            data-f-bold="true" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcProfitCols(bdr, month) }}</th>

          <th 
            class="bdr-result-table-text-align-end" 
            data-b-a-s="medium" 
            data-exclude="true"
          >{{ calcAllProfit(bdr).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            class="bdr-result-table-text-align-end hidden" 
            data-b-a-s="medium" 
            data-fill-color="FFFFCC00" 
            data-f-bold="true" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcAllProfit(bdr) }}</th>
        </tr>

        <!-- for bdr 3 -->
        <tr class="bdr-result-table-name-row">
          <th 
            class="bdr-result-table-point" 
            colspan="2" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium" 
            data-f-sz="12" 
            data-f-bold="true"
          >{{ bdr[3].name }}</th>
          <th 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium"
          ></th>
          <th 
            v-for="month in 12" 
            :key="month" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium"
          ></th>
        </tr>

        <!-- НАДО ПЕРЕЙТИ НА НАЛОГИ С ПОДКАТЕГОРИЯМИ!!! -->
        <tr v-for="child in bdr[3].children" :key="child.id">
          <th 
            class="bdr-result-table-point" 
            data-a-v="middle" 
            data-f-bold="true" 
            data-b-a-s="thin" 
            data-b-r-s="medium"
          >{{ child.external_number }}</th>
          <th 
            class="bdr-result-table-main-cell" 
            data-a-wrap="true" 
            data-a-v="middle"
            data-f-bold="true" 
            data-b-a-s="thin" 
            data-b-r-s="medium"
          >{{ child.name }}</th>

          <th 
            v-for="month in 12" 
            :key="month" 
            data-exclude="true"
            class="bdr-result-table-text-align-end"
            style="cursor: pointer"
            @click="calcMonthOperations(child.operations, month)"
          >
            {{ calcMonthSum(child.operations, month).toLocaleString() }}</th>
            <!-- hidden, for export -->
          <th 
            v-for="month in 12" 
            :key="month + 12" 
            class="bdr-result-table-text-align-end hidden"
            data-a-v="middle" 
            data-b-a-s="thin" 
            data-b-r-s="medium" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
            style="cursor: pointer"
            @click="calcMonthOperations(child.operations, month)"
          >{{ calcMonthSum(child.operations, month) }}</th>

          <th 
            class="bdr-result-table-text-align-end" 
            data-exclude="true"
          >{{ calcRowSum(child.operations).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            class="bdr-result-table-text-align-end hidden" 
            data-a-v="middle" 
            data-b-a-s="thin" 
            data-b-r-s="medium" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcRowSum(child.operations) }}</th>
        </tr>

        <tr class="bdr-result-table-name-row">
          <th 
            class="bdr-result-table-point" 
            colspan="2" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium" 
            data-f-sz="12" 
            data-f-bold="true"
          >ИТОГО ЗАТРАТ НА НАЛОГИ</th>

          <th 
            v-for="month in 12" 
            :key="month" 
            class="bdr-result-table-text-align-end" 
            data-exclude="true"
          >{{ calcColumnSum(bdr[3].children, month).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            v-for="month in 12" 
            :key="month + 12" 
            class="bdr-result-table-text-align-end hidden" 
            data-b-a-s="medium" 
            data-fill-color="FFFFCC00" 
            data-f-bold="true" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcColumnSum(bdr[3].children, month) }}</th>

          <th 
            class="bdr-result-table-text-align-end" 
            data-exclude="true"
          >{{ calcAllSums(bdr[3].children).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            class="bdr-result-table-text-align-end hidden" 
            data-b-a-s="medium" 
            data-fill-color="FFFFCC00" 
            data-f-bold="true" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcAllSums(bdr[3].children) }}</th>
        </tr>

        <!-- ЧИСТАЯ ПРИБЫЛЬ -->
        <tr class="bdr-result-table-name-row">
          <th 
            class="bdr-result-table-point" 
            colspan="2" 
            data-fill-color="FFFFCC00" 
            data-b-a-s="medium" 
            data-f-sz="12" 
            data-f-bold="true"
          >ЧИСТАЯ ПРИБЫЛЬ</th>
          <th 
            v-for="month in 12" 
            :key="month" 
            class="bdr-result-table-text-align-end bdr-result-table-net-profit" 
            data-exclude="true"
          >{{ calcNetProfitCols(bdr, month).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            v-for="month in 12" 
            :key="month + 12" 
            class="bdr-result-table-text-align-end bdr-result-table-net-profit hidden" 
            data-fill-color="ffb4c6e7"
            data-f-bold="true" 
            data-b-a-s="medium" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcNetProfitCols(bdr, month) }}</th>

          <th 
            class="bdr-result-table-text-align-end bdr-result-table-net-profit" 
            data-exclude="true"
          >{{ calcAllNetProfit(bdr).toLocaleString() }}</th>
          <!-- hidden, for export -->
          <th 
            class="bdr-result-table-text-align-end bdr-result-table-net-profit hidden" 
            data-fill-color="ffb4c6e7"
            data-f-bold="true" 
            data-b-a-s="medium" 
            data-t="n" 
            data-num-fmt="_(### ### ##0_)"
          >{{ calcAllNetProfit(bdr) }}</th>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { bdrTableMethods } from "@/mixins/bdrTable/bdrTableMethods.js";

export default {
  props: {
    bdr: {
      type: Array,
      required: true,
    },
    months: {
      type: Array,
      required: true,
    },
    year: {
      type: Number,
      required: true,
    }
  },
  mixins: [ bdrTableMethods ],
};
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border: 1px solid black;
  font-size: 10px;
}
th,
tr {
  border: 1px solid black;
}

.bdr-result-table {
  &-point {
    width: 35px;
  }

  &-main-cell {
    width: 350px;
  }

  &-header-text {
    font-weight: bold;
  }

  &-main-header {
    font-size: 12px;
    background-color: rgb(255, 255, 204);
  }

  &-name-row {
    background-color: rgb(255, 204, 0);
  }

  &-text-align-end {
    text-align: end;

    &.hidden {
      display: none;
    }
  }

  &-net-profit {
    background-color: rgb(180, 198, 231);
  }
}
.fix-alert {
  position: fixed;
  height: auto;
  right: 0;
  z-index: 10;
  margin-top: -9px;
}
</style>
